module.exports = __webpack_public_path__ + "media/newstyle/images/word-message-es-07acaa582fbc69450aa1fbe374511f65.svg";